import { render, staticRenderFns } from "./SummaryStep.vue?vue&type=template&id=1ba13974&scoped=true&"
import script from "./SummaryStep.vue?vue&type=script&lang=js&"
export * from "./SummaryStep.vue?vue&type=script&lang=js&"
import style0 from "./SummaryStep.vue?vue&type=style&index=0&id=1ba13974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba13974",
  null
  
)

export default component.exports